import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Notification {
  id: number;
  message: string;
  seen: boolean;
  createdAt?: string;
}

interface NotificationState {
  items: Notification[];
  isLoading: boolean;
}

// Sample initial notifications - would normally be fetched from API
const initialNotifications: Notification[] = [
  { id: 1, message: "Task - TSK-1 by User is overdue from 14-March-2023", seen: false },
  { id: 2, message: "Task - TSK-6 by User is overdue from 20-March-2023", seen: false },
  { id: 3, message: "Task - TSK-12 by User is overdue", seen: false },
  { id: 4, message: "Release: V0.05 is now available", seen: false },
];

const initialState: NotificationState = {
  items: initialNotifications,
  isLoading: false,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.items = action.payload;
      state.isLoading = false;
    },
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.items.unshift(action.payload);
    },
    markAsSeen: (state, action: PayloadAction<number>) => {
      const notification = state.items.find(item => item.id === action.payload);
      if (notification) {
        notification.seen = true;
      }
    },
    markAsUnseen: (state, action: PayloadAction<number>) => {
      const notification = state.items.find(item => item.id === action.payload);
      if (notification) {
        notification.seen = false;
      }
    },
    markAllAsSeen: (state) => {
      state.items.forEach(item => {
        item.seen = true;
      });
    },
    markAllAsUnseen: (state) => {
      state.items.forEach(item => {
        item.seen = false;
      });
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { 
  setNotifications, 
  addNotification, 
  markAsSeen, 
  markAsUnseen,
  markAllAsSeen,
  markAllAsUnseen,
  setLoading 
} = notificationSlice.actions;

export default notificationSlice.reducer; 